<script setup lang="ts">
import type { IconName } from '~/constants/icons'

withDefaults(defineProps<{
  to: string
  label: string
  icon: IconName
  active?: boolean
  prefetch?: boolean
  activeIndicatorClass?: string
  activeBackgroundClass?: string
}>(), {
  prefetch: true,
  activeIndicatorClass: 'bg-accent-2',
  activeBackgroundClass: 'bg-accent-2-soft',
})
</script>

<template>
  <NuxtLink
    :to="to"
    :prefetch="prefetch"
    class="relative flex h-12 flex-col items-center justify-center gap-0.5 px-1 text-center transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-2"
    :aria-current="active ? 'page' : undefined"
  >
    <span
      class="absolute top-0 left-1/2 h-0.5 w-6 -translate-x-1/2 rounded-full transition-opacity"
      :class="active ? `${activeIndicatorClass} opacity-100` : 'opacity-0'"
      aria-hidden="true"
    />
    <div
      class="flex flex-col items-center justify-center gap-0.5 rounded-md px-2 py-1 transition-colors"
      :class="active ? activeBackgroundClass : 'hover:bg-ink/6'"
    >
      <UIIcon :name="icon" size="sm" :tone="active ? 'info' : 'neutral'" />
      <UIText variant="micro" as="span" :tone="active ? 'info' : 'neutral'">
        {{ label }}
      </UIText>
    </div>
  </NuxtLink>
</template>
